"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRetryLink = exports.retryIf = void 0;
var retry_1 = require("@apollo/client/link/retry");
var INITIAL_DELAY = 500;
var MAX_RETRY_ATTEMPTS_TIME = 5;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var retryIf = function (error) {
    if (!error || !error.response || !error.response.status)
        return false;
    var response = error.response;
    if (response) {
        /*
            Why retry on 403(User is not authorized to access this resource with an explicit deny)?
                This error is unavoidable. Its a natural stage during token expire and refresh. AtoZMobile/ESS portal will
                be in charge of refresh the token. As tenant, our duty is to do more retries so we can pick up the refreshed
                token and make a success API call.
                Reference: https://amzn-pxt.slack.com/archives/C019L5LF5GR/p1678747888721249

        */
        if (response.status === 403) {
            return true;
        }
    }
    return false;
};
exports.retryIf = retryIf;
var createRetryLink = function () {
    return new retry_1.RetryLink({
        delay: {
            initial: INITIAL_DELAY,
            max: Infinity,
            jitter: true // avoid throttle
        },
        attempts: {
            max: MAX_RETRY_ATTEMPTS_TIME,
            retryIf: exports.retryIf
        }
    });
};
exports.createRetryLink = createRetryLink;
